import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Text } from '@dodilio/ui-design-lib';
import { HeroShell } from '../../components/HeroShell';
import { takeWaitingLink } from '../../followSignInLink';
import { handOffNow, takeWaitingHandOff } from '../../handoff';
import { restoreSession } from '../../auth';

/**
 * Back from ending someone else's Keycloak session: on with the new account's
 * one-time sign-in link, or with the hand-over that was waiting, or, if it's
 * too old by now, to the org step, which carries on with the session signup
 * stored.
 */
export const SignupContinue = () => {
    const navigate = useNavigate();
    const done = useRef(false);
    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const link = takeWaitingLink();
        if (link) { window.location.replace(link); return; }
        const waiting = takeWaitingHandOff();
        // The session to hand over is this tab's own, still stored: take it back first.
        if (waiting) { void restoreSession().catch(() => undefined).then(() => handOffNow(waiting)); return; }
        navigate('/signup/org', { replace: true });
    }, [navigate]);
    return (
        <HeroShell title="Signing you in">
            <Text size="2" color="gray" role="status">One moment…</Text>
        </HeroShell>
    );
};
